module.exports = __webpack_public_path__ + "img/GH-syoukai-top-logo.daed6cbf.webp";